<template>
  <div>
    <h1>クレカ決済の実装</h1>
    <p>勉強のために、Vue.jsとVuetifyを使用して、クレジットカード決済のUIを実装しました。</p>
    <a href="https://docs.pay.jp/v1/testcard" target="_blank">テストカード情報</a>を使用して、決済が可能です。
    <!-- <p><strong>実際に支払いが発生しますが、マジで何ももらえないので、気を付けてください。</strong></p> -->
    <br><br>
    <div>
      <PayBtn 
          name="テスト商品"
          price="1000"
          description="これはテスト商品です。"
        >
      </PayBtn>
    </div>
    <br>
    <p><strong>このページは、Vue.jsとVuetifyの学習用に作成されたもので、実際の決済処理は含まれていません。</strong></p>
  </div>
  <!-- 完了通知 -->
  <v-snackbar 
    v-model="toast_flag" timeout="1000"
    style="align-items: center; text-align-last: center;"
    color="red-accent-1"
  >
    {{ toast_msg }}
  </v-snackbar>
</template>

<script>
// 標準モジュール
import { ref } from 'vue';
import PayBtn from '@/components/PayJp/PayBtn.vue';

// 外部モジュール

// 独自モジュール

export default {
  name: 'PaymentPage',
  components: {
    PayBtn,
  },
  setup() {
    // ##########
    // 決済 # 
    // ##########
    const pay = async (amount) => {
      show_toast("決済中...")
      try {
        // TODO: 決済処理の実装
        // ここではダミーの処理を行う
        // await new Promise(resolve => setTimeout(resolve, 2000)); // 2秒待つ
      } catch (error) {
        show_toast("決済に失敗しました。");
        return
      }
      show_toast(`決済完了: ${amount}円`);
    }

    // #################
    // トースト #
    // #################
    const toast_flag = ref(false)
    const toast_msg = ref("")
    const show_toast = (msg) => {
        toast_msg.value = msg
        toast_flag.value = true
    }

    return {
        // 決済
        pay,
        // トースト
        toast_flag,
        toast_msg,
        show_toast,
    };
  },
}
</script>
